import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import { injectIntl } from 'react-intl';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { CustomTableWithHeader } from 'Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox';

class CustomHistoryController extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    setValidationForApp = () => {
        let checkData = [];
        if (this.props.historyType && this.props.validation
            && this.props.historyType === CustomTypes.CUSTOM_HISTORY_SINGLE) {
            checkData.push(this.props.validation);
            return checkData;
        }

        if (this.props.historyType && this.props.validations
            && this.props.historyType === CustomTypes.CUSTOM_HISTORY_MULTI) {
            if (this.props.validations.includes(";")) {
                checkData = this.props.validations.split(";");
            } else {
                checkData.push(this.props.validations);
            }
            return checkData;
        }

        if (DataUtil.isFrancetv()) return ["published"];
        if (DataUtil.isPMDB()) return ["status"]

        return [];
    }

    saveHistoryData = (action) => {
        if (this.props.clip && this.props.clip.id) {
            let updatedHistory = this.makeAction(this.props.user.id, action);
            if (action === CustomTypes.EDIT) {
                this.props.setCustomHistory({ saveHistory: { clipid: this.props.clip.id, history: updatedHistory } });
            }
        }
    }

    addHistoryData = (action) => {
        if (this.props.clip && this.props.clip.id) {
            let updatedHistory = this.makeAction(this.props.user.id, action);
            let currentData = this.refreshData(this.props.customHistory.showHistory, updatedHistory);
            if (updatedHistory) {
                if (action === CustomTypes.EDIT) {
                    this.props.setCustomHistory({ saveHistory: { clipid: this.props.clip.id, history: updatedHistory } });
                } else {
                    setTimeout(() => { this.props.updateMetadata("clip", this.props.clip.id, { history: updatedHistory }); }, 1000);
                }
            }
            if (currentData) this.props.setCustomHistory({ showHistory: currentData });
        }
    }

    makeAction = (user, action) => {
        if (user) {
            let obj = {};
            try {
                if (action && action !== "") {
                    obj = { "date": DataUtil.getCurrentDayTimestamp(), "action": action, "user": user };
                    return "," + JSON.stringify(obj);
                }
            } catch (eror) {
                console.log("LAMTEST error JSON.parse");
            }
        }
        return [{ "date": "", "action": "", "user": "" }];
    }

    refreshData = (data, action) => {
        if (data && data.clipid) {
            let currentHistory = data.history + action;
            return { clipid: data.clipid, history: currentHistory }
        }
        return null;
    }

    setShowHistory = (addHistory, item = null) => {
        if (addHistory && addHistory !== "") {
            const { showHistory } = this.props.customHistory;
            if ((!item && showHistory && showHistory.clipid) || (item && showHistory && showHistory.clipid == item)) {
                let history;
                if (showHistory.history) history = showHistory.history + addHistory;
                else history = addHistory;
                this.props.setCustomHistory({ showHistory: { clipid: showHistory.clipid, history } });
            }
        }
    }

    setUpdatedHistory = (updatedHistory) => {
        if (this.props.clip && this.props.clip.id && updatedHistory && updatedHistory !== "") {
            this.props.updateMetadata("clip", this.props.clip.id, { history: updatedHistory });
        }
    }

    updateMassObjects = () => {
        if (this.props.saved) {
            if (this.props.clips && this.props.clips.length) {
                this.props.clips.forEach((item) => {
                    if (item) {
                        let updatedHistory = this.makeSingleData(this.props.validation, this.props.clipList.clips[item].metadata, this.props.updatedElements);
                        let isChanged = false;
                        for (let i in this.props.updatedElements) {
                            if (this.props.elements[i] !== this.props.clipList.clips[item].metadata[i]) {
                                isChanged = true;
                            }
                        }
                        if (isChanged) {
                            this.props.updateMetadata("clip", item, { history: updatedHistory });
                            this.setShowHistory(updatedHistory, item);
                        }
                    }
                })
            }
        }
    }

    toggleData = ({ validation, checkValue, elements }) => {
        if (validation) {
            let addTo = "";
            addTo = (parseInt(elements[validation]) === checkValue) ? "_yes" : "_no";

            return this.makeAction(this.props.user.id, `edit_${validation}${addTo}`);
        }
        return "";
    }

    makeSingleData = (validation, updatedData, elements) => {
        let updatedHistory = this.makeAction(this.props.user.id, CustomTypes.EDIT);
        if (elements[validation] && updatedData) {
            let original = this.state[`original${validation}`] || "0";
            let updated = updatedData[validation] || "0";
            if (parseInt(updated) !== parseInt(original)) {
                updatedHistory = this.toggleData({ field: this.props.validation, checkValue: 1, elements });
            }
        }
        return updatedHistory;
    }

    makeHistoryData = () => {
        let updatedHistory = '';
        let showHistory = '';
        let checkData = this.setValidationForApp();
        checkData.forEach(item => {
            if (this.props.elements[item] !== this.state[`original${item}`]) {
                let history;
                if (item === CustomTypes.CUSTOM_PUBLISHED)
                    history = this.toggleData({ validation: item, checkValue: 1, elements: this.props.elements });
                else
                    history = this.makeAction(this.props.user.id, `edit_${item}`);
                updatedHistory += history;
                showHistory += history;
                this.setState({ [`original${item}`]: '' });
            }
        });

        if (this.props.elements && (JSON.stringify(this.props.elements) !== this.state.origElements)) {
            showHistory += this.makeAction(this.props.user.id, CustomTypes.EDIT);
            this.setState({ origElements: '' });
        }
        this.setUpdatedHistory(updatedHistory);
        this.setShowHistory(showHistory);
    }

    setOrigEditFields = (prevProps) => {
        let checkData = this.setValidationForApp();
        checkData.forEach(item => {
            this.setState({ [`original${item}`]: prevProps.elements[item] ? prevProps.elements[item] : '' });
        })

        let origElements = prevProps.elements ? JSON.stringify(prevProps.elements) : '';
        this.setState({ origElements });
    }

    checkHistoryType = () => {
        if (this.props.historyType
            && (this.props.historyType === CustomTypes.CUSTOM_HISTORY_SINGLE
                || this.props.historyType === CustomTypes.CUSTOM_HISTORY_MASS
                || this.props.historyType === CustomTypes.CUSTOM_HISTORY_MULTI
                || this.props.historyType === CustomTypes.CUSTOM_HISTORY_STANDARD)) {
            return true;
        }
        return false;
    }

    verifySingleData = (prevProps) => {
        if (this.props.historyType
            && this.props.historyType === CustomTypes.CUSTOM_HISTORY_SINGLE
            && this.props.validation && this.props.elements
            && (prevProps.elements[this.props.validation] !== this.props.elements[this.props.validation])) {
            return true;
        }
        return false;
    }

    verifyMultiData = (prevProps) => {
        if (this.props.historyType
            && this.props.historyType === CustomTypes.CUSTOM_HISTORY_MULTI
            && this.props.validations && this.props.elements) {
            let checkData = this.setValidationForApp();
            let isChanged = false;
            checkData.forEach(item => {
                if (prevProps.elements[item] !== this.props.elements[item]) {
                    isChanged = true;
                }
            })
            if (isChanged) return true;
        }
        return false;
    }

    handleAppEditMode = (prevProps) => {
        if (!this.props.customHistory.editing) {
            this.saveHistoryData(CustomTypes.EDIT);
            this.setOrigEditFields(prevProps);
            this.props.setCustomHistory({ ...this.props.customHistory, editing: true });
        }

        if (prevProps.loading && !this.props.loading && this.props.customHistory.saving) {
            setTimeout(() => {
                this.makeHistoryData(prevProps);
                this.props.setCustomHistory({ ...this.props.customHistory, saving: false, editing: false });
            }, 1000);
        }
    }

    buildStandard = (prevProps) => {
        if (DataUtil.isFrancetv()) {
            this.handleAppEditMode(prevProps);
        } else {
            if (prevProps.mode !== this.props.mode && this.props.mode === CustomTypes.EDIT) {
                this.saveHistoryData(CustomTypes.EDIT);
                this.setOrigEditFields(prevProps);
            }
            if (prevProps.mode === CustomTypes.EDIT && this.props.mode === CustomTypes.TEXT) {
                this.makeHistoryData(prevProps);
            }
        }

        if (!prevProps.clipDeleted && this.props.clipDeleted) {
            this.addHistoryData(CustomTypes.DELETE);
        }
    }

    setUpStandard = () => {
        const { elements } = this.props;
        let clipKey = elements[CustomTypes.ID] ? CustomTypes.ID : CustomTypes.CLIPID;
        if (elements && elements[clipKey]) {
            let currentData;
            if (!(this.props.customHistory.showHistory && elements[clipKey] && (this.props.customHistory.showHistory.clipid === elements[clipKey]))) {
                if (elements && elements["history"])
                    currentData = { clipid: elements[clipKey], history: elements.history };
                else if (this.props.clip.metadata["history"])
                    currentData = { clipid: this.props.clip.metadata[clipKey], history: this.props.clip.metadata["history"] };
                else
                    currentData = { clipid: elements[clipKey], history: "" }
            }
            if (currentData) this.props.setCustomHistory({ showHistory: currentData });
        }
    }

    initData = () => {
        if (this.checkHistoryType()) {
            switch (this.props.historyType) {
                case CustomTypes.CUSTOM_HISTORY_STANDARD:
                    return this.setUpStandard();
                default:
                    return this.setOrigEditFields(this.props);
            }
        }
    }

    controlHitoryType = (prevProps) => {
        if (this.checkHistoryType()) {
            switch (this.props.historyType) {
                case CustomTypes.CUSTOM_HISTORY_MASS:
                    return this.updateMassObjects();
                case CustomTypes.CUSTOM_HISTORY_SINGLE:
                    if (this.verifySingleData(prevProps)) {
                        return this.makeHistoryData(prevProps);
                    }
                    return;
                case CustomTypes.CUSTOM_HISTORY_MULTI:
                    if (this.verifyMultiData(prevProps)) {
                        return this.makeHistoryData(prevProps);
                    }
                    return;
                default:
                    return this.buildStandard(prevProps);
            }
        }
    }

    renderList = () => {
        let data = [];
        const { showHistory } = this.props.customHistory;
        if (showHistory && showHistory.history) {
            data = DataUtil.getDataForTable(showHistory.history, this.props.users);
        }
        return (
            <div>
                <CustomTableWithHeader isLang="true" display={this.props.display} data={data} others={this.props} />
            </div>);
    }

    renderContent = () => {
        if (this.checkHistoryType()) {
            switch (this.props.historyType) {
                case CustomTypes.CUSTOM_HISTORY_STANDARD:
                    return this.renderList();
                default:
                    return <div></div>;
            }
        }
        return <div></div>;
    }

    componentDidUpdate(prevProps) {
        this.controlHitoryType(prevProps);
    }

    componentDidMount() {
        this.initData();
    }

    render() {
        return this.renderContent();
    }
}

const mapStateToProps = (state) => ({
    customFlexAppConfig: state.customData.customFlexAppConfig,
    user: state.auth.user,
    uiConfig: state.customData.customUiConfigForApp,
    customHistory: state.customData.customHistory,
    users: state.admin.users,
    clipList: state.clipList,
    metadataLoading: state.metadata.loading,
    rooms: state.rooms.rooms

});

const mapDispatchToProps = (dispatch) => ({
    setCustomHistory: (currentHistory) => dispatch(actions.setCustomHistory(currentHistory)),
    updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata(type, id, metadata))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomHistoryController));


